import { useState } from "react";
import { MapContainer, TileLayer, Marker, Polyline, useMapEvents } from "react-leaflet";
import { MapPin } from "lucide-react";
import L from "leaflet";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl:       require("leaflet/dist/images/marker-icon.png"),
  shadowUrl:     require("leaflet/dist/images/marker-shadow.png"),
});

const INDIA_CENTER = [22.5, 80.0];
const INDIA_BOUNDS = L.latLngBounds(L.latLng(6.5, 68.0), L.latLng(37.5, 97.5));

function pinIcon(color) {
  return L.divIcon({
    className: "", iconSize: [26, 26], iconAnchor: [13, 26],
    html: `<div style="
      width:26px;height:26px;border-radius:50% 50% 50% 4px;
      transform:rotate(-45deg);background:${color};
      border:2px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,0.35);
    "></div>`,
  });
}

const SOURCE_ICON      = pinIcon("#16A34A");
const DESTINATION_ICON = pinIcon("#DC2626");

function ClickCatcher({ onClick }) {
  useMapEvents({ click(e) { onClick(e.latlng); } });
  return null;
}

// Standalone point-picker map — click to drop a pin for whichever mode
// ("source" or "destination") is currently active.
export default function TripPointPicker({ source, destination, mode, onPick }) {
  const [hint] = useState(true); // eslint-disable-line no-unused-vars

  function handleClick(latlng) {
    onPick(mode, { lat: latlng.lat, lng: latlng.lng });
  }

  const line = source && destination
    ? [[source.lat, source.lng], [destination.lat, destination.lng]]
    : null;

  return (
    <div style={{ position: "relative", width: "100%", height: 320, borderRadius: 10, overflow: "hidden", border: "1px solid #E5E7EB" }}>
      <MapContainer
        center={INDIA_CENTER} zoom={5} minZoom={4} maxZoom={18}
        maxBounds={INDIA_BOUNDS} maxBoundsViscosity={0.8}
        zoomControl={true}
        style={{ width: "100%", height: "100%" }}
      >
        <TileLayer
          url="/api/tiles/{s}/{z}/{x}/{y}?v=2"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          subdomains="abc" maxZoom={18}
        />
        <ClickCatcher onClick={handleClick} />
        {line && <Polyline positions={line} pathOptions={{ color: "#2563EB", weight: 3, opacity: 0.7, dashArray: "6 6" }} />}
        {source && <Marker position={[source.lat, source.lng]} icon={SOURCE_ICON} />}
        {destination && <Marker position={[destination.lat, destination.lng]} icon={DESTINATION_ICON} />}
      </MapContainer>

      <div style={{
        position: "absolute", top: 10, left: 10, zIndex: 900,
        background: "rgba(255,255,255,0.95)", borderRadius: 8,
        padding: "6px 10px", fontSize: 12, fontWeight: 600,
        color: mode === "source" ? "#16A34A" : "#DC2626",
        display: "flex", alignItems: "center", gap: 6,
        boxShadow: "0 1px 6px rgba(0,0,0,0.1)",
      }}>
        <MapPin size={13} />
        Click the map to set the {mode === "source" ? "source" : "destination"} point
      </div>
    </div>
  );
}
